if (!window.Eurus.loadedScript.has('cart-term.js')) {
  window.Eurus.loadedScript.add('cart-term.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xCartTerm', (message) => ({
        message: message,
        checked: false,
        // CLONE by Ana: o aviso so aparece depois de o cliente tentar finalizar a compra,
        // nao logo que a gaveta abre.
        showError: false,
        init() {
          Alpine.store('xCartHelper').termsAccepted = false;

          this.$watch('checked', () => {
            Alpine.store('xCartHelper').termsAccepted = this.checked;
            if (this.checked) this.showError = false;
            this.save();
          });

          document.addEventListener('eurus:cart:validate', (e) => {
            if (!this.checked) {
              Alpine.store('xCartHelper').validated = false;
              // So mostra o aviso quando a validacao vem do botao de finalizar compra
              if (e && e.detail && e.detail.isCheckOut) this.showError = true;
            }
          });

          // Disparado pelo botao de finalizar compra quando os termos nao estao aceites
          document.addEventListener('clone:terms:error', () => {
            if (!this.checked) this.showError = true;
          });
        },
        save() {
          clearTimeout(this.t);

          const func = () => {
            var status = this.checked ? 'agreed' : 'not agreed';
            Alpine.store('xCartHelper').updateCart({
              attributes: {
                'Terms and conditions': status
              }
            });
          }

          this.t = setTimeout(() => {
            func();
          }, 200);
        }
      }));
    })
  });
};
